import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap"
import store from "@/store";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/plugins/fontawsome";
import router from './router';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { createMetaManager } from 'vue-meta'
import ToastPlugin from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import Vue3ConfirmDialogBox from "vue3-confirm-dialog-box";

const metaManager = createMetaManager()


createApp(App)
    .use(store)
    .use(router)
    .use(VueSweetalert2)
    .use(metaManager)
    .use(ToastPlugin)
    .use(Vue3ConfirmDialogBox)
    .component("font-awesome-icon", FontAwesomeIcon)
    .mount('#app')